<template>
  <div>
    <span
      class="close"
      aria-hidden="true"
      @click.stop="onClose"
    />
    <div
      class="section-overlay-container"
      @click.stop="onClose"
    >
      <div
        class="zoom-container"
        ref="section"
      >
        <div class="summary-container-v2">
          <div
            class="sub-section-title"
            v-if="title"
          >
            {{ title.replaceAll(';', ',') }}
          </div>
          <div id="zoomContainer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PinchZoom from 'pinch-zoom-js';

export default {
  name: 'SummarySectionZoom',
  props: {
    title: String,
    zoomElements: Array,
  },
  mounted() {
    this.zoomElements.forEach((zoomElement, idx) => {
      const clonedZoom = zoomElement.cloneNode(true);
      clonedZoom.id = `clonedZoom${idx}`;
      document.getElementById('zoomContainer').appendChild(clonedZoom);
    });
    this.initZoomable();
  },
  beforeDestroy() {
    this.zoom.destroy();
  },
  data() {
    return {
      zoomOptions: {
        maxZoom: 5,
        minZoom: 0.2,
        lockDragAxis: false,
      },
    };
  },
  methods: {
    onClose(e) {
      if (!this.$refs.section.contains(e.target)) {
        this.$emit('closing');
      }
    },
    initZoomable() {
      this.zoom = new PinchZoom(this.$refs.section, this.zoomOptions);
    },
  },
};
</script>
<style lang="scss" scoped>
  .section-overlay-container {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(#000, 0.75);
    z-index: 998;
    padding-top: 16px;
    padding-left: 8px;
    padding-right: 8px;
    box-sizing: border-box;
    .overlay-content {
      background: white;
    }
    .zoom-container {
      padding-top: 20px;
      background: white;
      width: 100%;
      .sub-section-title {
        font-weight: bold;
        text-align: center;
        padding: 0;
      }
      .summary-container-v2 {
        padding-bottom: 30px;

        .sub-section-title {
          padding: 5px 5px;
          font-size: 13px;
          text-align: center;
          text-transform: uppercase;
          font-weight: bold;
          background: white;
        }
      }
    }
  }
</style>
